<template>
  <div class="step0">
    <div class="header border-1px">{{ $t('labels.acc.idVerf') }}</div>
    <div class="level border-1px">
      <!--LV 0-->
      <!-- <div class="level-item border-1px">
          <div class="level-item-left">
            <div class="level-item-left-icon">LV 0</div>
            <div class="level-item-left-title">等级0</div>
            <div class="level-item-left-txt">邮件或手机短信验证所需的级别信息。</div>
          </div>
          <div class="level-item-right">
            <div class="level-item-right-success">
              <img src="@/assets/images/success.png" alt="" class="img">
              <div class="txt">已认证</div>
            </div>
          </div>
      </div>-->
      <!--LV 1-->
      <div class="level-item border-1px">
        <div class="level-item-left">
          <div class="level-item-left-icon">{{ $t('labels.acc.idVerf.lvl1') }}</div>
          <!-- <div class="level-item-left-title">等级1</div> -->
          <div class="level-item-left-txt">{{ $t('labels.acc.idVerf.lvl1.desc') }}</div>
        </div>
        <div class="level-item-right">
          <!--<div class="level-item-right-wait">
            <div class="txt">{{ $t('labels.acc.idVerf.comingSoon') }}</div>
          </div>-->
          <div class="level-item-right-success" v-if="Getter_User_Info.primaryAuthStatus === 1">
            <img src="@/assets/images/success.png" alt class="img" />
            <div class="txt">{{ $t('labels.acc.idVerf.verified') }}</div>
          </div>
          <!-- primaryAuthStatus: 8 = not submitted -->
          <div
            class="level-item-right-wait"
            v-if="Getter_User_Info.primaryAuthStatus === 8"
            @click="showMaxRegisterModal"
          >
            <div class="txt">{{ $t('labels.acc.idVerf.maxRegist') }}</div>
            <img src="@/assets/images/arrow-right.png" alt class="img" />
          </div>
        </div>
      </div>
      <!--LV 2-->
      <div class="level-item border-1px">
        <div class="level-item-left">
          <div class="level-item-left-icon">{{ $t('labels.acc.idVerf.lvl2') }}</div>
          <!-- <div class="level-item-left-title">等级2</div> -->
          <div class="level-item-left-txt">{{ $t('labels.acc.idVerf.lvl2.desc') }}</div>
        </div>
        <div class="level-item-right">
          <div
            class="level-item-right-success"
            style="cursor: none;"
            v-if="Getter_User_Info.advancedAuthStatus === 1"
          >
            <img src="@/assets/images/success.png" alt class="img" />
            <div class="txt">{{ $t('labels.acc.idVerf.verified') }}</div>
          </div>
          <div
            class="level-item-right-wait"
            v-else-if="Getter_User_Info.advancedAuthStatus === 0"
            @click="jump('/usercenter/authentication', 2, 1)"
          >
            <div class="txt">{{ $t('labels.acc.idVerf.pending') }}</div>
          </div>
          <!-- advancedAuthStatus: 8 = not submitted -->
          <div
            class="level-item-right-wait"
            v-else-if="
              (Getter_User_Info.advancedAuthStatus === 8 || Getter_User_Info.advancedAuthStatus === 9) &&
                Getter_User_Info.primaryAuthStatus === 1
            "
            @click="jump('/usercenter/authentication', 2, 1)"
          >
            <div class="txt">{{ $t('labels.acc.idVerf.verifyNow') }}</div>
            <img src="@/assets/images/arrow-right.png" alt class="img" />
          </div>
          <div
            class="level-item-right-wait"
            v-else-if="(Getter_User_Info.advancedAuthStatus === 2)"
            @click="jump('/usercenter/authentication', 2, 1)"
          >
            <div class="txt">{{ $t('labels.acc.idVerf.rejected') }}</div>
            <img src="@/assets/images/arrow-right.png" alt class="img" />
          </div>
          <div class="level-item-right-disable" v-else>{{ $t('labels.acc.idVerf.plsCompLvl1') }}</div>
          <!-- <div class="level-item-right-wait"  @click="jump('/usercenter/authentication',2,1)">
              <div class="txt">去认证</div>
              <img src="@/assets/images/arrow-right.png" alt="" class="img">
          </div>-->
        </div>
      </div>
    </div>
    <MaxRegisterModal
      v-if="maxWalletModalShow"
      :show.sync="maxWalletModalShow"
      :pkg-type="maxWalletPkgType"
      :title="$t('max.register.title.kyc')"
      :desc="$t('max.register.desc.kyc')"
      :subDesc="$t('max.register.subDesc.kyc')"
      :medium="true"
      v-model="maxWalletModalShow"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { getterTypes } from '@/store/getter-types';
import MaxRegisterModal from '@/components/MaxRegisterModal/v2';

export default {
  name: 'authentication',
  components: { MaxRegisterModal },
  data() {
    return {
      maxWalletPkgType: 'GET_KYC',
      maxWalletModalShow: false
    };
  },
  props: {},
  watch: {},
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info])
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    jump(path, type, step) {
      this.$router.push({ path: path, query: { type: type, step: step } });
    },
    showMaxRegisterModal() {
      this.maxWalletModalShow = true;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import 'IndexPage.styl';
</style>
